// extracted by mini-css-extract-plugin
module.exports = {"app":"bm_c9","appTitle":"bm_db","bigCard":"bm_f8","appSubtitle":"bm_f9","appSubtitle_dark":"bm_gb","iconContent":"bm_gc","bigIcon":"bm_gd"};